import { render, staticRenderFns } from "./BlogCategory.vue?vue&type=template&id=7a522252&"
import script from "./BlogCategory.vue?vue&type=script&lang=js&"
export * from "./BlogCategory.vue?vue&type=script&lang=js&"
import style0 from "./BlogCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports